export enum OrderType {
  TakeAway = 1,
  Delivery = 3,
}
